import { Component, OnInit } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { CardiovascularAssessment } from 'src/app/calvin-emr-shared/models/assessments/cardiovascular.model';

@Component({
  selector: 'app-cardiovascular-info',
  templateUrl: './cardiovascular-info.component.html',
  styleUrls: ['./cardiovascular-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent],
})
export class CardiovascularInfoComponent
  extends AssessmentInfoComponent<CardiovascularAssessment>
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void { }

  get isIrregularPulse() {
    return this.data.pulsePattern ? 'Yes' : 'No';
  }

  get isJVDPresent() {
    return this.data.jvd ? 'Yes' : 'No';
  }

  get hasGNPE() {
    return this.data.gnpe ? 'Yes' : 'No';
  }

  get isNormalCapRefill() {
    return this.data.capRefill ? 'Yes' : 'No';
  }

  get isPaceMaker() {
    return this.data.pacemaker ? 'Yes' : 'No';
  }
}
